import currency from 'currency.js'
import axios from 'axios'
import moment from 'moment'

export const BASE_URL = "https://topilmalar.davxizmat.uz"
export const BASE_ID_GOV = "https://sso.egov.uz/sso/oauth/Authorization.do"
export const BASE_KEY_CLOAK = "https://id.adliya.uz/realms/smart-realm/protocol/openid-connect/auth"
export const ID_GOV_CLIENT_ID = "is_topilmalar"
export const ID_GOV_CLIENT_KEY_CLOAK = "smart-client"
export const ID_GOV_STATE = "BACK_OFFICE"
export const ID_GOV_SCOPE = "topilmalar"
export const ID_GOV_RESPONSE = "one_code"
export const ID_GOV_RESPONSE_KEY_CLOAK = "code"

// LOCAL STORAGE
export const TOKEN = "topilmalar.davxizmat.uz"
export const REFRESH_TOKEN = "topilmalar.davxizmat.uz.ref"
export const USER_DATA = "topilmalar.davxizmat.uz.user"
export const ROLE = "topilmalar.davxizmat.uz.role"

// SYSTEM ROLE
export const ADMIN = "ADMIN"
export const OPERATOR = "DXM_THING" || "DXM_THING_CREATE"
export const REGIONAL_ADMIN = "REGIONAL_ADMIN"
export const MONITORING = "MONITORING"


export const JUSTICE = "ADLIYA"
export const REGIONAL_DEPARTMENT = "REGIONAL_DEPARTMENT"

//  TOPILMA BUYUM VA HUJJAT STATUSLARI

export const GIVEN_OWNER = "FOUND_GIVEN_OWNER" // Hujjat. Egasiga topshirish. Murojaat qilgan vaqtda
export const STATE_PROPERTY = "FOUND_OBJ_STATE_PROPERTY" // Topilma davlat mulkiga o`tkazilgan
export const INFORM_FOUNDER = "FOUND_OBJ_INFORM_FOUNDER" // Buyum. Ashyoni topib olgan shaxsga uning ashyoga nisbatan mulk huquqi vujudga kelganligi to‘g‘risida xabar berish. (Topilgan shaxsni xabardor qilish) Olti oydan so’ng
export const GIVEN_FOUNDER = "FOUND_OBJ_GIVEN_FOUNDER" // Buyum. Topib olgan shaxsga topshirish.
export const PUT_AUCTION = "FOUND_OBJ_PUT_TO_AUCTION" // Buyum. “E-auksion” joylashtirish.
export const SOLD_AUCTION = "FOUND_OBJ_SOLD_IN_AUCTION" // Buyum. “E-auksion” orqali sotilgan.
export const GIVEN_ENTITY = "FOUND_SEND_DOC_TO_GIVEN_ENTITY" // Hujjat. Shaxsni tasdiqlovchi hujjatlar, guvohnomalar va turli xil rasmiy hujjatlarni hujjatni bergan tashkilotga yuborish. (Tegishli tashkilotga yuborish) Bir oydan so’ng
export const SEND_ARCHIVE = "FOUND_SEND_DOC_TO_ARCHIVE" // Hujjat. Viloyat va tuman (shahar) davlat arxivlariga yoki idoraviy arxivlarga topshirish Bir oydan so’ng
export const AFTER_EXPERTIZE = "FOUND_SEND_DOC_TO_DESTROY_AFTER_EXPERTIZE" // Hujjat. Hujjatlarning qimmatliligini aniqlash ekspertizasiga ko‘ra saqlash muddati tugagan hujjatlar belgilangan tartibda yo‘q qilishga ajratish. Bir oydan so’ng

export const FOUND = "FOUND"
export const THING = "THING"
export const LOST = "LOST"
export const DOCUMENT = "DOCUMENT"

// TOASTER SMS XABARLARI
export const NECESSARY_INFORMATION = "Zaruriy ma'lumotlarini filtrlab oling!"
export const WORK_FINISHED = "Ushbu ariza bilan ishlash yakunlagan"
export const INPUT_MSG = "Iltimos, to`liq kiriting"
export const SELECT_STATUS = "Iltimos, holatlardan birini tanlang"
export const ERROR_UUID = "Siz kiritgan UUID bazada mavjud emas!"
export const EMPTY_DATA = "Ma`lumot topilmadi"
export const NO_DATA = "Kiritilmagan..."
export const COPY_SERIAL_NUMBER = "Reestrdagi seriya va raqamidan nusxa olind"
export const SEND_SMS_LOSER = "Ashyo egasiga sms jo`natildi"
export const ERROR_MSG = "Xatolik yuz berdi, iltimos sahifani yangilab qayta urinib ko`ring"
export const ERROR_SERVER = "server 500 error"

// SOCIAL NETWORK
export const INSTAGRAM = "https://www.instagram.com/adliyanews/"
export const TELEGRAM = "https://t.me/adliyangiliklari"
export const FACEBOOK = "https://www.facebook.com/minjustuz"
export const YOUTUBE = "https://www.youtube.com/c/Adliya"
export const PHONE = "+998972070066"
export const MAIL = "info@adliya.uz"

const role = localStorage.getItem(ROLE)

export const PATH_URL = `/${role === ADMIN || role === REGIONAL_ADMIN ? 'cabinet-administrator' : role === MONITORING ? 'monitoring' : 'operator'}`

export const http_auth = axios.create({
    baseURL: BASE_URL,
    headers: {
        Accept: "application/json",
        Authorization: `bearer ${localStorage.getItem(TOKEN)}`
    }
})

export const http_no_auth = axios.create({
    baseURL: BASE_URL,
    headers: {
        Accept: "application/json"
    }
})

export const http_file = axios.create({
    baseURL: BASE_URL,
    headers: {
        Accept: "*/*",
        Authorization: `bearer ${localStorage.getItem(TOKEN)}`
    }
})

export const httpONE_ID = axios.create({
    baseURL: "https://sso.egov.uz/sso/oauth/Authorization.do?response_type=one_code&client_id=is_topilmalar&scope=topilmalar&state=BACK_OFFICE&redirect_uri=",
    headers: {
        Accept: "application/json"
    }
})

export const rmSpace = str => {
    if (str !== null || str !== undefined) return str?.replace(/ /g, '')
    return null
}
const getNameOf = (activityMap, id, locale) => {
    if (locale === 'uz') {
        return activityMap?.names_uz[id] !== null ? activityMap?.names_uz[id] : ''
    } else {
        return activityMap?.names[id] !== null ? activityMap?.names[id] : ''
    }
}

const getNameOfArr = (activityMap, arr, locale) => {
    const result = []
    for (const i in arr) {
        if (locale === 'uz') {
            if (activityMap?.names_uz[arr[i]] !== null) {
                result.push({
                    id: arr[i],
                    name: activityMap?.names_uz[arr[i]]
                })
            }
        } else {
            if (activityMap?.names[arr[i]] !== null) {
                result.push({
                    id: arr[i],
                    name: activityMap?.names[arr[i]]
                })
            }
        }
    }
    return result
}

const isAllowed = (arr1, arr2) => arr1?.filter((o) => arr2?.indexOf(o) > -1)?.sort((a, b) => a - b)

export const algoritmTree = ({activity_tree, allowed_ids}) => {
    const tree = activity_tree?.tree
    const final = []
    const arr = []
    for (const i in tree) {
        if (isAllowed(allowed_ids, tree[i])?.length !== 0 && isAllowed(allowed_ids, tree[i]) !== undefined) {
            arr.push(isAllowed(allowed_ids, tree[i]))
        }
    }
    for (const i in arr[0]) {
        final.push({
            id: arr[0][i],
            name: getNameOf(activity_tree, arr[0][i], "uz"),
            child: getNameOfArr(activity_tree, arr[parseInt(i) + 1], 'uz')
        })
    }
    return final
}

export const algoritmOkedSpacelTree = ({frequently_used_okeds}) => {
    const final = []
    for (const i in frequently_used_okeds?.graph[0]) {
        final.push({
            id: frequently_used_okeds?.graph[0][i],
            name: getNameOf(frequently_used_okeds, frequently_used_okeds?.graph[0][i]),
            child: getNameOfArr(frequently_used_okeds, frequently_used_okeds?.graph[parseInt(i) + 1])
        })
    }
    return final
}


export const getDate = date => moment(date).format('LLL')

export const isObjEmpty = obj => Object.keys(obj).length === 0

export const legal_status = (status) => {
    switch (status) {
        case 'Complete':
            return 'Faoliyat korsatayorgan'

        default:
            break
    }

}
// ** Returns K format from a number
export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = html => html.replace(/<\/?[^>]+(>|$)/g, '')

// ** Checks if the passed date is today
const isToday = date => {
    const today = new Date()
    return (
        /* eslint-disable operator-linebreak */
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
        /* eslint-enable */
    )
}

export const fCurrency = {
    format: (value, {separator = ' ', precision = 0, decimal = '.', symbol = ''} = {}) => {
        if (Number(value) === Math.floor(value)) {
            precision = 0
        }
        return currency(value, {separator, precision, decimal, symbol}).format()
    },
    add: (value, addValue, {precision = 2} = {}) => {
        return String(currency(value, {precision}).add(addValue))
    },
    subtract: (value, subtractValue, {precision = 2} = {}) => {
        return String(currency(value, {precision}).subtract(subtractValue))
    },
    normalize: (value, {precision = 2} = {}) => {
        return String(currency(value, {precision}))
    }
}


/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = {month: 'short', day: 'numeric', year: 'numeric'}) => {
    if (!value) return value
    return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
    const date = new Date(value)
    let formatting = {month: 'short', day: 'numeric'}

    if (toTimeForCurrentDay && isToday(date)) {
        formatting = {hour: 'numeric', minute: 'numeric'}
    }

    return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem('userData')
export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
    if (userRole === 'admin') return '/'
    if (userRole === 'client') return '/access-control'
    return '/login'
}

// ** React Select Theme Colors
export const selectThemeColors = theme => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary25: '#7367f01a', // for option hover bg-color
        primary: '#7367f0', // for selected option bg-color
        neutral10: '#7367f0', // for tags bg-color
        neutral20: '#ededed', // for input border-color
        neutral30: '#ededed' // for input hover border-color
    }
})
